import { TDataLayer } from "@porsche-customer/globaldatalayer-events/projects/navi/all/types";
import {
  ClickElementType,
  ClickElementTypes,
  ElementTypes,
  EventAction,
  EventActions,
} from "@phn/utility/constants/analytics";
import { GlobalDataLayerService } from "@phn/services/analytics/global-data-layer-service";
import analyticsManager from "./analytics-manager";
import { removeLastRoutingSegment } from "@phn/entities/routing-key";

interface DataLayerEventSenderType {
  datalayerEventAction: EventAction;
  analyticsId: string;
  text: string;
  link: string;
  elementId: string;
  clickElementType: ClickElementType;
  customDatalayerProperties: TDataLayer;
}
export function sendDataLayerEvent({
  datalayerEventAction = EventActions.NAVIGATION_CLICK,
  analyticsId,
  text,
  link,
  elementId,
  clickElementType,
  customDatalayerProperties = {},
}: DataLayerEventSenderType): void {
  GlobalDataLayerService.getInstance().pushDataLayerEvent(
    datalayerEventAction,
    {
      componentClick: {
        clickElementId: analyticsId,
        clickElementName: text,
        targetElement: analyticsManager.getModelTargetElement(elementId, text),
        clickElementType,
        ...(clickElementType === ClickElementTypes.Link
          ? { targetUrl: link }
          : {}),
      },
      componentDisplay: {
        displayElementId: analyticsManager.calculateDisplayElementId(elementId),
        displayElementType: analyticsManager.calculateDisplayElementType(
          removeLastRoutingSegment(elementId),
          ElementTypes.menuItem,
        ),
        displayElementName: text,
      },
      ...customDatalayerProperties,
      ...(datalayerEventAction === EventActions.MODEL_RANGE_CLICK
        ? {
            car: {
              ...(customDatalayerProperties.car ?? {}),
              modelRangeName: text.toLowerCase(),
            },
          }
        : {}),
    },
  );
}
